import { useUserContext } from "@/components/user-context/user-context-provider";
import { checkFeatureFlagGate } from "@/utils/feature-flags/check-feature-flag";
import { featureFlags } from "@/utils/feature-flags/feature-flag-manifest";

import { LoggedInDevAIFree } from "./free/logged-in-devai-free";
import { LoggedInRovoDevStandard } from "./standard/logged-in-rovo-dev-standard";

export const LoggedInDevAI = () => {
    const { edition } = useUserContext();

    if (
        edition === "free" &&
        checkFeatureFlagGate(featureFlags.enableRovoDevBetaSignup)
    ) {
        return <LoggedInDevAIFree />;
    }

    return <LoggedInRovoDevStandard />;
};
